// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 创建权限 POST /apiAdmin/permission */
export async function permissionControllerCreatePermission(
  body: API.CreatePermissionDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataPermissionDataDtoDto>("/apiAdmin/permission", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据ID获取权限 GET /apiAdmin/permission/${param0} */
export async function permissionControllerGetPermissionById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.PermissionControllerGetPermissionByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataPermissionDataDtoDto>(
    `/apiAdmin/permission/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新权限 PUT /apiAdmin/permission/${param0} */
export async function permissionControllerUpdatePermission(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.PermissionControllerUpdatePermissionParams,
  body: API.UpdatePermissionDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataPermissionDataDtoDto>(
    `/apiAdmin/permission/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除权限 DELETE /apiAdmin/permission/${param0} */
export async function permissionControllerDeletePermission(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.PermissionControllerDeletePermissionParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/permission/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取权限列表 POST /apiAdmin/permission/list */
export async function permissionControllerGetPermissionList(
  body: API.QueryPermissionDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataPermissionDataDtoArrayDto>(
    "/apiAdmin/permission/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取菜单树（仅菜单类型） GET /apiAdmin/permission/menuTree */
export async function permissionControllerGetMenuTree(options?: {
  [key: string]: any;
}) {
  return request<API.ResultDataPermissionTreeDtoArrayDto>(
    "/apiAdmin/permission/menuTree",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 获取权限树 GET /apiAdmin/permission/tree */
export async function permissionControllerGetPermissionTree(options?: {
  [key: string]: any;
}) {
  return request<API.ResultDataPermissionTreeDtoArrayDto>(
    "/apiAdmin/permission/tree",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
